module.exports = function animate(options) {

  const start = performance.now();

  requestAnimationFrame(function animate() {
    // timeFraction от 0 до 1
    let timeFraction = (performance.now() - start) / options.duration;
    if (timeFraction > 1) timeFraction = 1;

    // текущее состояние анимации
    const progress = options.timing(timeFraction);

    options.draw(progress);

    if (timeFraction < 1) {
      requestAnimationFrame(animate);
    } else {
      if (options.callback) options.callback();
    }
  });

};
